import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// redux
import { connect } from 'react-redux';
import { getBreakpointFromManor } from 'ctm-components';

import { Typography } from '@comparethemarketau/manor-typography';

import { ProductPriceMonthlyNotice } from '../../products/products/common/product_price_monthly_notice';
import { paymentFrequencyStateMapping, frequencyFilterTypes } from '../../products/filters/common/filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    productPriceMonthlyNoticeContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing[4]
    },
    notice: {
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey800,
        lineHeight: theme.lineHeight.relaxed
    }
}));

const _PriceMonthlyNotice = ({ frequencyFilter, productMonthlyFirstMonth, productAnnualisedMonthlyPremium }) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        frequencyFilter === 'monthly' && (
            breakpoint !== 'xs'
                ? (
                    <ProductPriceMonthlyNotice
                        productMonthlyFirstMonth={productMonthlyFirstMonth}
                        productAnnualisedMonthlyPremium={productAnnualisedMonthlyPremium}
                    />
                )
                :  (
                    <div className={classes.productPriceMonthlyNoticeContainer}>
                        <Typography className={classes.notice}>{`1st month: $${productMonthlyFirstMonth}`}</Typography>
                        <Typography className={classes.notice}>{`Total: $${productAnnualisedMonthlyPremium}`}</Typography>
                    </div>
                )
        )
    );
};

_PriceMonthlyNotice.propTypes = {
    productMonthlyFirstMonth: PropTypes.number,
    productAnnualisedMonthlyPremium: PropTypes.number,
    /**
     * monthly or annual from redux
     */
    frequencyFilter: PropTypes.oneOf(frequencyFilterTypes)
};

const PriceMonthlyNotice = connect(paymentFrequencyStateMapping)(_PriceMonthlyNotice);

export { PriceMonthlyNotice, _PriceMonthlyNotice };
